import ForgotPasswordPage from '@/pages/login/forgot-password/forgot-password';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/forgot-password')({
  component: ForgotPasswordPage,
});
